import './photo-slider';
import './detail-tabs';
import './stores';
import './ask-question';
